export enum ContactRole {
    Underwriter = 'Underwriter',
    Retailer = 'Retailer',
    Insured = 'Insured',
    SubmissionBox = 'SubmissionBox',
    Broker = 'Broker',
}
